import React from 'react';
import { NodeHealth } from '../NodeHealth';

import './CloudUiDisplay.css'


export interface CloudUiDisplayParam {
    isShowing:boolean,
    device:string,
    url: string,
    invUuid?: string,
}

export interface CloudUiDisplayInterface {
    device?: string,
    trackedDevice?: string,
    isShowing: boolean,
    url?: string,
    invUuid?: string,
    close: ()=>void,
    open: (param:CloudUiDisplayParam)=>void,
    setTrackedDevice?: (device?:string)=>void,
}


interface CloudUiDisplayProps {
    cloudUiDisplayInterface: CloudUiDisplayInterface
}


export class CloudUiDisplay extends React.Component<CloudUiDisplayProps> {

    constructor(props: CloudUiDisplayProps) {
        super(props)

        this.handleCloudUiCloseButtonClick = this.handleCloudUiCloseButtonClick.bind(this);
        //this.handleOpenInAnotherWindow = this.handleOpenInAnotherWindow.bind(this);
    }
    componentDidMount(){
        if(this.props.cloudUiDisplayInterface.isShowing){
            const iFrame = document.getElementById("iframe_a") as HTMLIFrameElement;
            iFrame.addEventListener("load", ()=> {
                // Initalize the page once it is fully loaded
                console.log('iFrame loaded')

                const thisCloudUiInterface = this.props.cloudUiDisplayInterface;
                const session_user = window.sessionStorage.getItem('cred1');
                const session_pass = window.sessionStorage.getItem('cred2');
                const token = window.sessionStorage.getItem('token');
                //const invUuid = window.sessionStorage.getItem('invUuid');
                const thisInvUuid = this.props.cloudUiDisplayInterface.invUuid;
                const credobj = {cred1:session_user,cred2:session_pass,cred3:(Date.now()+5000).toString(),token:token,invUuid:thisInvUuid};
                //console.log(credobj)
                const jsoncredobj = JSON.stringify(credobj);

                const sendMessage = function () {
                    if(iFrame !== null && iFrame.contentWindow !== null){
                        if(thisCloudUiInterface.url)
                            iFrame.contentWindow.postMessage(jsoncredobj, thisCloudUiInterface.url);//"*");
                    }
                };
                sendMessage();
            });
        }
    }

    handleCloudUiCloseButtonClick(){
        this.props.cloudUiDisplayInterface?.close();
    }
/*
    handleOpenInAnotherWindow(){

        //SPAWN TO NEW TAB?
        const strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
        const URL = this.props.cloudUiDisplayInterface.url+'\?=suppressLoginScreen';
        let newWindow = window.open(URL, "_blank");//, strWindowFeatures);
        //if(newWindow !== null){
        const sendMessageFunc = (event:MessageEvent<any>) => {
            //if(event.data === "new window loaded"){
            console.log(event.data)
            //if(event.origin === this.props.cloudUiDisplayInterface.url){
                const thisCloudUiInterface = this.props.cloudUiDisplayInterface;
                const session_user = window.sessionStorage.getItem('cred1');
                const session_pass = window.sessionStorage.getItem('cred2');
                //const invUuid = window.sessionStorage.getItem('invUuid');
                const credobj = {cred1:session_user,cred2:session_pass,cred3:(Date.now()+30000).toString(),invUuid:undefined};
                //console.log(credobj)
                const jsoncredobj = JSON.stringify(credobj);

                const sendMessage = function () {
                    if(newWindow !== null){
                        if(thisCloudUiInterface.url)
                            newWindow.postMessage(jsoncredobj, thisCloudUiInterface.url);//"*");
                    }
                };
                sendMessage();
                window.removeEventListener("message",sendMessageFunc);
            //}

        }
        window.addEventListener("message", sendMessageFunc);

    }
*/
    render(){
        let displayTitle = this.props.cloudUiDisplayInterface.device;
        if(this.props.cloudUiDisplayInterface.device){
            displayTitle = NodeHealth.remapDeviceName(this.props.cloudUiDisplayInterface.device)
        }
        let onTopDisplay;
        if(this.props.cloudUiDisplayInterface.isShowing){
            onTopDisplay  =
                <div style={{width:'100%',height:'100%',position:'absolute',display:'grid',zIndex:20002}}>
                    <div className={'ui-display-window'}>
                        <div className={'ui-display-bar'}>
                            <label className="status-metric-title-big">{displayTitle}</label>
                            <div className="closebtn" style={{cursor:'pointer'}} onClick={this.handleCloudUiCloseButtonClick}>&times;</div>
                        </div>
                        <div style={{display:'flex',width:'1400px',height:'860px',backgroundColor:'white',zoom:'0.8',justifySelf:'center',alignSelf:'center',zIndex:20001}}>
                            <iframe id="iframe_a" src={this.props.cloudUiDisplayInterface.url+'\?=suppressLoginScreen'} name="iframe_a" height="100%" width="100%" title="iFrameCloudUiDisplay" style={{borderWidth:'0px'}}></iframe>
                        </div>
                    </div>
                    <div style={{width:'100%',height:'100%',position:'absolute',backgroundColor:'gray',zIndex:20000, opacity:0.7}}></div>
                </div>
        }

        return(
            <>
            {onTopDisplay}
            </>
        )
    }
}
export default CloudUiDisplay
